export enum FileType {
	AVATAR = 'avatar',
	SIGNATURE = 'signature'
}
